import { PageNode } from "../../types/PageNode";

export const SocialNetworkService = {
    replaceTextInHTML: (htmlString: string, replaceFn: (text: string) => string) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);

        let node;
        while ((node = walker.nextNode())) {
            node.textContent = replaceFn(node.textContent || "");
        }

        return doc.body.innerHTML;
    },
    initSocialsInPage: (nodes: PageNode[], socialName: string, socialLink: string, social: string) => {
         return nodes.map((node: PageNode) => {
            let updatedNode = { ...node };

            if (updatedNode.socialSettings?.social === social) {
                const { link: connectedLink, text: connectedText } = updatedNode.socialSettings;

                if (connectedLink) {
                    updatedNode = {
                        ...updatedNode,
                        onClickAction: {
                            type: 0,
                            value: socialLink
                        }
                    };
                }
                if(connectedText && updatedNode?.value){
                    updatedNode = {
                        ...updatedNode,
                        value: SocialNetworkService.replaceTextInHTML(updatedNode.value, () => socialName)
                    };
                }
            }

            if (updatedNode.nodes) {
                updatedNode.nodes = SocialNetworkService.initSocialsInPage(updatedNode.nodes, socialName, socialLink, social);
            }

            return updatedNode;
        });
    },
    
}